import React from "react";
import "../main.css";
import { Table } from "semantic-ui-react";

class TopHeading {
    constructor(name, columnHeadings) {
        this.name = name;
        this.columnHeadings = columnHeadings;
    }
}

class TableBuilder {
    constructor(topHeadings) {
        this.topHeadings = topHeadings;
    }

    buildTable(sheetName, studentsData) {
        this.sheetName = sheetName; // Hack to help us hide the Group column on 3-1 form Reserve tabs
        return (
            <div style={{ overflow: "auto" }} className="table-styling">
                <Table celled>
                    <Table.Header className="text-center">
                        {this.buildTopHeadings()}
                        {this.buildColumnHeadings()}
                    </Table.Header>
                    <Table.Body>
                        {this.buildTableContent(studentsData)}
                    </Table.Body>
                </Table>
            </div>
        );
    }

    buildTopHeadings() {
        return (
            <Table.Row
                style={{
                    fontFamily: "Modelica",
                    fontWeight: 800,
                }}
            >
                {this.topHeadings.map((
                    topHeading,
                    index // index param is here so React can track deltas. Apparently that's a thing? If I'm wrong, remove it!
                ) => (
                    <Table.HeaderCell
                        className="table-header-1"
                        colSpan={topHeading.columnHeadings.length}
                    >
                        {topHeading.name}
                    </Table.HeaderCell>
                ))}
            </Table.Row>
        );
    }

    buildColumnHeadings() {
        return (
            <Table.Row>
                {this.topHeadings.map((topHeading, topHeadingIndex) =>
                    topHeading.columnHeadings.map(
                        (columnHeading, columnHeadingIndex) => (
                            <Table.HeaderCell
                                className={[
                                    "table-header-2 ",
                                    columnHeadingIndex ===
                                    topHeading.columnHeadings.length - 1
                                        ? "border-right-purple"
                                        : "",
                                ]}
                                style={{
                                    borderLeft:
                                        columnHeadingIndex === 0
                                            ? "none"
                                            : "1px solid rgba(34,36,38,.1)",
                                }}
                            >
                                {columnHeading}
                            </Table.HeaderCell>
                        )
                    )
                )}
            </Table.Row>
        );
    }

    buildTableContent(studentsData) {
        return studentsData.map((studentData, studentRowIndex) => {
            return (
                <Table.Row key={studentData["rowIndex"]}>
                    {this.topHeadings.map((topHeading, topHeadingIndex) => {
                        return topHeading.columnHeadings.map(
                            (columnHeading, columnHeadingIndex) => {
                                if (
                                    this.sheetName === "Reserves" &&
                                    columnHeading === "Group"
                                ) {
                                    return;
                                }
                                let cellData = studentData.fields.find(
                                    element => element.field === columnHeading
                                );
                                let validationResult = "";
                                if (cellData) {
                                    validationResult =
                                        cellData["validationResult"] ===
                                            "FAILED" ||
                                        cellData["validationResult"] ===
                                            "WARNING"
                                            ? "failed-cell"
                                            : "";
                                }
                                return (
                                    <Table.Cell
                                        className={[
                                            columnHeadingIndex ===
                                            topHeading.columnHeadings.length - 1
                                                ? "border-right-purple"
                                                : "table-row-1", // Is this the end of a group?
                                            validationResult,
                                        ]}
                                    >
                                        {cellData ? cellData["value"] : ""}
                                    </Table.Cell>
                                );
                            }
                        );
                    })}
                </Table.Row>
            );
        });
    }
}

export default class ResultsTable extends React.Component {
    constructor(props) {
        super(props);
    }

    _20201219TableTopHeadings = [
        new TopHeading("Pupil Details", [
            "First Name",
            "Surname",
            "Year",
            "Student or parent email",
            "Gender",
        ]),
        new TopHeading("Only required for National Tuition Programme", [
            "Unique pupil number (UPN)",
            "Date of birth",
            "Pupil eligible for Pupil Premium (PP)?",
            "Pupil has special educational needs or disability (SEND)?",
        ]),
        new TopHeading("Tuition", ["Subject", "Level", "Day", "Time"]),
        new TopHeading("Grade Data", [
            "Current grade",
            "Target grade",
            "Exam board",
            "Tier",
            "Important modules, topics and texts",
            "How this student learns best",
        ]),
        new TopHeading("Where", ["Location (School/Home)"]),
    ];

    _20210823TableTopHeadings = [
        new TopHeading("Pupil Details", [
            "First Name",
            "Surname",
            "Year",
            "Pupil email",
            "Parent email",
            "Gender",
        ]),
        new TopHeading("Only required for National Tuition Programme", [
            "Unique pupil number (UPN)",
            "Date of birth",
            "Pupil eligible for Pupil Premium (PP)?",
            "Pupil has special educational needs or disability (SEND)?",
        ]),
        new TopHeading("Tuition", ["Subject", "Level", "Day", "Time"]),
        new TopHeading("Grade Data", [
            "Current grade",
            "Target grade",
            "Exam board",
            "Tier",
            "Important modules, topics and texts",
            "How this pupil learns best",
        ]),
        new TopHeading("Where", ["Lesson location"]),
    ];

    _20210120TableTopHeadings = [
        new TopHeading("Pupil Details", [
            "Group",
            "First Name",
            "Surname",
            "Year",
            "Student or parent email",
            "Gender",
        ]),
        new TopHeading("Only required for National Tuition Programme", [
            "Unique pupil number (UPN)",
            "Date of birth",
            "Pupil eligible for Pupil Premium (PP)?",
            "Pupil has special educational needs or disability (SEND)?",
        ]),
        new TopHeading("Tuition", ["Subject", "Level", "Day", "Time"]),
        new TopHeading("Grade Data", [
            "Current grade",
            "Target grade",
            "Exam board",
            "Tier",
            "Important modules, topics and texts",
            "How this student learns best",
        ]),
    ];
    _20210218TableTopHeadings = this._20210120TableTopHeadings; // Nothing changed in the top headings for this iteration

    _20210824TableTopHeadings = [
        new TopHeading("Pupil Details", [
            "Group",
            "First Name",
            "Surname",
            "Year",
            "Pupil email",
            "Parent email",
            "Gender",
        ]),
        new TopHeading("Only required for National Tuition Programme", [
            "Unique pupil number (UPN)",
            "Date of birth",
            "Pupil eligible for Pupil Premium (PP)?",
            "Pupil has special educational needs or disability (SEND)?",
        ]),
        new TopHeading("Tuition", ["Subject", "Level", "Day", "Time"]),
        new TopHeading("Grade Data", [
            "Current grade",
            "Target grade",
            "Exam board",
            "Tier",
            "Important modules, topics and texts",
            "How this pupil learns best",
        ]),
        new TopHeading("Where", ["Lesson location"]),
    ];

    getBuilder = formKey => {
        // For now, ignore formKey type as the date is enough to differentiate for now and I'm hacking this
        switch (formKey.version) {
            case "20201219":
                return new TableBuilder(this._20201219TableTopHeadings);
            case "20210823":
                return new TableBuilder(this._20210823TableTopHeadings);
            case "20210120":
                return new TableBuilder(this._20210120TableTopHeadings);
            case "20210218":
                return new TableBuilder(this._20210218TableTopHeadings);
            case "20210824":
                return new TableBuilder(this._20210824TableTopHeadings);
        }
    };

    buildTable = () => {
        if (!this.props.formData) {
            return;
        }

        let nameOfSheetToRender = this.props.sheetToRender;

        let formData = this.props.formData;
        let formKey = formData.formKey;
        let dataOfSheetToRender = formData.sheets.find(
            sheetElement => sheetElement.name === nameOfSheetToRender
        );

        if (dataOfSheetToRender) {
            let builder = this.getBuilder(formKey);
            return builder.buildTable(
                nameOfSheetToRender,
                dataOfSheetToRender.students
            );
        }
    };

    render() {
        return <>{this.buildTable()}</>;
    }
}
